import React from 'react';
import type { ProductVisual, ScreenId } from '../../types/product';
import { PosTabletScreen } from './screens/PosTabletScreen';
import { ReceiptPhone } from './screens/ReceiptPhone';
import { CheckoutScreen } from './screens/CheckoutScreen';
import { PaymentsScreen } from './screens/PaymentsScreen';
import { ReturnsScreen } from './screens/ReturnsScreen';
import { StaffSalesScreen } from './screens/StaffSalesScreen';
import { MockCardView } from './mock/MockCardView';
import { DevicesComposite } from './mock/DevicesComposite';
function PosHeroComposite() {
  return <div className="relative mx-auto w-full max-w-[620px] pb-10 pr-6 sm:pr-10" data-id="element-1232" data-mp="17h68brt60a0">
      <PosTabletScreen data-id="element-1233" data-mp="ezx7p8529q8t" />
      <div className="absolute bottom-0 right-0 origin-bottom-right scale-[0.78] sm:scale-100" data-id="element-1234" data-mp="a1lt6k3tmrk9">
        <ReceiptPhone data-id="element-1235" data-mp="oyw3hq4q9ree" />
      </div>
    </div>;
}
const screens: Record<ScreenId, React.ComponentType> = {
  'pos-hero': PosHeroComposite,
  checkout: CheckoutScreen,
  payments: PaymentsScreen,
  returns: ReturnsScreen,
  'staff-sales': StaffSalesScreen
};
type ProductVisualViewProps = {
  visual: ProductVisual;
  className?: string;
};
export function ProductVisualView({
  visual,
  className = ''
}: ProductVisualViewProps) {
  if (visual.kind === 'image') {
    return <img src={visual.src} alt={visual.alt} className={`w-full object-contain ${className}`} data-id="element-1236" data-mp="22y4ucvfiuj8z" />;
  }
  if (visual.kind === 'card') {
    return <div className={className} role="img" aria-label={`Kayko screen: ${visual.card.title}`} data-id="element-1237" data-mp="2cxvtxbixvofx">
        <div className="w-full max-w-[380px]" data-id="element-1238" data-mp="2hwgu5ay6y84d">
          <MockCardView card={visual.card} data-id="element-1239" data-mp="2hv5qdb4qx0d9" />
        </div>
      </div>;
  }
  if (visual.kind === 'devices') {
    return <div className={className} role="img" aria-label={`Kayko ${visual.tablet.module} on a tablet and phone`} data-id="element-1240" data-mp="2mpt4cg24icdl">
        <DevicesComposite tablet={visual.tablet} phone={visual.phone} data-id="element-1241" data-mp="2vo55hc0m8ska" />
      </div>;
  }
  const Screen = screens[visual.id];
  return <div className={className} role="img" aria-label="Kayko product screen" data-id="element-1242" data-mp="30o9jmve1xb7c">
      <Screen data-id="element-1243" data-mp="10kfhfos9y1tp" />
    </div>;
}